<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3.08331C13.8892 7.18915 13.8892 13.8108 10 17.9166"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 17.9166C6.11084 13.8108 6.11084 7.18915 10 3.08331"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 3C14.1517 3 17.5 6.34833 17.5 10.5C17.5 14.6517 14.1517 18 10 18"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 18C5.84833 18 2.5 14.6517 2.5 10.5C2.5 6.34833 5.84833 3 10 3"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.92505 7.99998H17.075"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.92505 13H17.075"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
